import * as x from "react";
import s, { useContext as _e, useRef as P, forwardRef as ie, useState as Ie, useEffect as k, useMemo as ee, Children as Vt } from "react";
import { _ as A, q as ct, ah as Gt, e as Ft, P as re, y as st, z as ut, n as N, C as ce, j as dt, h as Ae, K as qt, L as Ut, R as Xt, I as Yt, J as Jt, b as gt, a as ft, v as mt, $ as vt, d as J, c as je, m as se, ai as Ee, u as ne, aj as Qt, g as Zt, l as Kt, B as kt, af as eo, E as to, M as oo } from "./CSSMotionList.js";
import { o as ro } from "./omit.js";
import { w as no, d as pt } from "./warning.js";
import { _ as bt, j as ae, i as ao, P as ze, u as lo } from "./ContextIsolator.js";
import { D as io } from "./index.js";
import { c as ht, i as co } from "./reactNode.js";
import * as Ct from "react-dom";
import { u as so, a as uo } from "./useSize.js";
import { R as go } from "./LoadingOutlined.js";
import { _ as $e } from "./extends.js";
import { g as fo } from "./compact-item.js";
var te = A({}, Ct), mo = te.version, Oe = te.render, vo = te.unmountComponentAtNode, ue;
try {
  var po = Number((mo || "").split(".")[0]);
  po >= 18 && (ue = te.createRoot);
} catch {
}
function rt(e) {
  var t = te.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  t && ct(t) === "object" && (t.usingClientEntryPoint = e);
}
var le = "__rc_react_root__";
function bo(e, t) {
  rt(!0);
  var o = t[le] || ue(t);
  rt(!1), o.render(e), t[le] = o;
}
function ho(e, t) {
  Oe == null || Oe(e, t);
}
function Co(e, t) {
  if (ue) {
    bo(e, t);
    return;
  }
  ho(e, t);
}
function yo(e) {
  return Te.apply(this, arguments);
}
function Te() {
  return Te = bt(/* @__PURE__ */ ae().mark(function e(t) {
    return ae().wrap(function(r) {
      for (; ; ) switch (r.prev = r.next) {
        case 0:
          return r.abrupt("return", Promise.resolve().then(function() {
            var n;
            (n = t[le]) === null || n === void 0 || n.unmount(), delete t[le];
          }));
        case 1:
        case "end":
          return r.stop();
      }
    }, e);
  })), Te.apply(this, arguments);
}
function So(e) {
  vo(e);
}
function xo(e) {
  return Pe.apply(this, arguments);
}
function Pe() {
  return Pe = bt(/* @__PURE__ */ ae().mark(function e(t) {
    return ae().wrap(function(r) {
      for (; ; ) switch (r.prev = r.next) {
        case 0:
          if (ue === void 0) {
            r.next = 2;
            break;
          }
          return r.abrupt("return", yo(t));
        case 2:
          So(t);
        case 3:
        case "end":
          return r.stop();
      }
    }, e);
  })), Pe.apply(this, arguments);
}
const Eo = (e, t) => {
  if (process.env.NODE_ENV !== "production") {
    const o = parseInt(x.version.split(".")[0], 10), r = Object.keys(Ct);
    process.env.NODE_ENV !== "production" && no(o < 19 || r.includes("createRoot"), "compatible", "antd v5 support React is 16 ~ 18. see https://u.ant.design/v5-for-19 for compatible.");
  }
  return Co(e, t), () => xo(t);
};
let $o = Eo;
function Oo(e) {
  return $o;
}
const Bo = (e) => {
  const {
    componentCls: t,
    colorPrimary: o
  } = e;
  return {
    [t]: {
      position: "absolute",
      background: "transparent",
      pointerEvents: "none",
      boxSizing: "border-box",
      color: `var(--wave-color, ${o})`,
      boxShadow: "0 0 0 0 currentcolor",
      opacity: 0.2,
      // =================== Motion ===================
      "&.wave-motion-appear": {
        transition: [`box-shadow 0.4s ${e.motionEaseOutCirc}`, `opacity 2s ${e.motionEaseOutCirc}`].join(","),
        "&-active": {
          boxShadow: "0 0 0 6px currentcolor",
          opacity: 0
        },
        "&.wave-quick": {
          transition: [`box-shadow ${e.motionDurationSlow} ${e.motionEaseInOut}`, `opacity ${e.motionDurationSlow} ${e.motionEaseInOut}`].join(",")
        }
      }
    }
  };
}, Ro = Gt("Wave", (e) => [Bo(e)]), yt = `${Ft}-wave-target`;
function Be(e) {
  return e && e !== "#fff" && e !== "#ffffff" && e !== "rgb(255, 255, 255)" && e !== "rgba(255, 255, 255, 1)" && !/rgba\((?:\d*, ){3}0\)/.test(e) && // any transparent rgba color
  e !== "transparent";
}
function Ho(e) {
  const {
    borderTopColor: t,
    borderColor: o,
    backgroundColor: r
  } = getComputedStyle(e);
  return Be(t) ? t : Be(o) ? o : Be(r) ? r : null;
}
function Re(e) {
  return Number.isNaN(e) ? 0 : e;
}
const wo = (e) => {
  const {
    className: t,
    target: o,
    component: r,
    registerUnmount: n
  } = e, a = x.useRef(null), i = x.useRef(null);
  x.useEffect(() => {
    i.current = n();
  }, []);
  const [l, c] = x.useState(null), [u, d] = x.useState([]), [g, v] = x.useState(0), [m, b] = x.useState(0), [E, p] = x.useState(0), [h, _] = x.useState(0), [H, f] = x.useState(!1), C = {
    left: g,
    top: m,
    width: E,
    height: h,
    borderRadius: u.map((S) => `${S}px`).join(" ")
  };
  l && (C["--wave-color"] = l);
  function L() {
    const S = getComputedStyle(o);
    c(Ho(o));
    const O = S.position === "static", {
      borderLeftWidth: I,
      borderTopWidth: j
    } = S;
    v(O ? o.offsetLeft : Re(-parseFloat(I))), b(O ? o.offsetTop : Re(-parseFloat(j))), p(o.offsetWidth), _(o.offsetHeight);
    const {
      borderTopLeftRadius: y,
      borderTopRightRadius: W,
      borderBottomLeftRadius: w,
      borderBottomRightRadius: G
    } = S;
    d([y, W, G, w].map((D) => Re(parseFloat(D))));
  }
  if (x.useEffect(() => {
    if (o) {
      const S = re(() => {
        L(), f(!0);
      });
      let O;
      return typeof ResizeObserver < "u" && (O = new ResizeObserver(L), O.observe(o)), () => {
        re.cancel(S), O == null || O.disconnect();
      };
    }
  }, []), !H)
    return null;
  const q = (r === "Checkbox" || r === "Radio") && (o == null ? void 0 : o.classList.contains(yt));
  return /* @__PURE__ */ x.createElement(st, {
    visible: !0,
    motionAppear: !0,
    motionName: "wave-motion",
    motionDeadline: 5e3,
    onAppearEnd: (S, O) => {
      var I, j;
      if (O.deadline || O.propertyName === "opacity") {
        const y = (I = a.current) === null || I === void 0 ? void 0 : I.parentElement;
        (j = i.current) === null || j === void 0 || j.call(i).then(() => {
          y == null || y.remove();
        });
      }
      return !1;
    }
  }, ({
    className: S
  }, O) => /* @__PURE__ */ x.createElement("div", {
    ref: ut(a, O),
    className: N(t, S, {
      "wave-quick": q
    }),
    style: C
  }));
}, No = (e, t) => {
  var o;
  const {
    component: r
  } = t;
  if (r === "Checkbox" && !(!((o = e.querySelector("input")) === null || o === void 0) && o.checked))
    return;
  const n = document.createElement("div");
  n.style.position = "absolute", n.style.left = "0px", n.style.top = "0px", e == null || e.insertBefore(n, e == null ? void 0 : e.firstChild);
  const a = Oo();
  let i = null;
  function l() {
    return i;
  }
  i = a(/* @__PURE__ */ x.createElement(wo, Object.assign({}, t, {
    target: e,
    registerUnmount: l
  })), n);
}, _o = (e, t, o) => {
  const {
    wave: r
  } = x.useContext(ce), [, n, a] = dt(), i = Ae((u) => {
    const d = e.current;
    if (r != null && r.disabled || !d)
      return;
    const g = d.querySelector(`.${yt}`) || d, {
      showEffect: v
    } = r || {};
    (v || No)(g, {
      className: t,
      token: n,
      component: o,
      event: u,
      hashId: a
    });
  }), l = x.useRef(null);
  return (u) => {
    re.cancel(l.current), l.current = re(() => {
      i(u);
    });
  };
}, St = (e) => {
  const {
    children: t,
    disabled: o,
    component: r
  } = e, {
    getPrefixCls: n
  } = _e(ce), a = P(null), i = n("wave"), [, l] = Ro(i), c = _o(a, N(i, l), r);
  if (s.useEffect(() => {
    const d = a.current;
    if (!d || d.nodeType !== 1 || o)
      return;
    const g = (v) => {
      !ao(v.target) || // No need wave
      !d.getAttribute || d.getAttribute("disabled") || d.disabled || d.className.includes("disabled") || d.className.includes("-leave") || c(v);
    };
    return d.addEventListener("click", g, !0), () => {
      d.removeEventListener("click", g, !0);
    };
  }, [o]), !/* @__PURE__ */ s.isValidElement(t))
    return t ?? null;
  const u = qt(t) ? ut(Ut(t), a) : a;
  return ht(t, {
    ref: u
  });
};
process.env.NODE_ENV !== "production" && (St.displayName = "Wave");
var Io = function(e, t) {
  var o = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (o[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
    t.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (o[r[n]] = e[r[n]]);
  return o;
};
const xt = /* @__PURE__ */ x.createContext(void 0), jo = (e) => {
  const {
    getPrefixCls: t,
    direction: o
  } = x.useContext(ce), {
    prefixCls: r,
    size: n,
    className: a
  } = e, i = Io(e, ["prefixCls", "size", "className"]), l = t("btn-group", r), [, , c] = dt(), u = x.useMemo(() => {
    switch (n) {
      case "large":
        return "lg";
      case "small":
        return "sm";
      default:
        return "";
    }
  }, [n]);
  if (process.env.NODE_ENV !== "production") {
    const g = pt("Button.Group");
    g.deprecated(!1, "Button.Group", "Space.Compact"), process.env.NODE_ENV !== "production" && g(!n || ["large", "small", "middle"].includes(n), "usage", "Invalid prop `size`.");
  }
  const d = N(l, {
    [`${l}-${u}`]: u,
    [`${l}-rtl`]: o === "rtl"
  }, a, c);
  return /* @__PURE__ */ x.createElement(xt.Provider, {
    value: n
  }, /* @__PURE__ */ x.createElement("div", Object.assign({}, i, {
    className: d
  })));
}, nt = /^[\u4E00-\u9FA5]{2}$/, Le = nt.test.bind(nt);
function Wr(e) {
  return e === "danger" ? {
    danger: !0
  } : {
    type: e
  };
}
function at(e) {
  return typeof e == "string";
}
function oe(e) {
  return e === "text" || e === "link";
}
function To(e, t) {
  if (e == null)
    return;
  const o = t ? " " : "";
  return typeof e != "string" && typeof e != "number" && at(e.type) && Le(e.props.children) ? ht(e, {
    children: e.props.children.split("").join(o)
  }) : at(e) ? Le(e) ? /* @__PURE__ */ s.createElement("span", null, e.split("").join(o)) : /* @__PURE__ */ s.createElement("span", null, e) : co(e) ? /* @__PURE__ */ s.createElement("span", null, e) : e;
}
function Po(e, t) {
  let o = !1;
  const r = [];
  return s.Children.forEach(e, (n) => {
    const a = typeof n, i = a === "string" || a === "number";
    if (o && i) {
      const l = r.length - 1, c = r[l];
      r[l] = `${c}${n}`;
    } else
      r.push(n);
    o = i;
  }), s.Children.map(r, (n) => To(n, t));
}
["default", "primary", "danger"].concat(Xt(ze));
const De = /* @__PURE__ */ ie((e, t) => {
  const {
    className: o,
    style: r,
    children: n,
    prefixCls: a
  } = e, i = N(`${a}-icon`, o);
  return /* @__PURE__ */ s.createElement("span", {
    ref: t,
    className: i,
    style: r
  }, n);
}), lt = /* @__PURE__ */ ie((e, t) => {
  const {
    prefixCls: o,
    className: r,
    style: n,
    iconClassName: a
  } = e, i = N(`${o}-loading-icon`, r);
  return /* @__PURE__ */ s.createElement(De, {
    prefixCls: o,
    className: i,
    style: n,
    ref: t
  }, /* @__PURE__ */ s.createElement(go, {
    className: a
  }));
}), He = () => ({
  width: 0,
  opacity: 0,
  transform: "scale(0)"
}), we = (e) => ({
  width: e.scrollWidth,
  opacity: 1,
  transform: "scale(1)"
}), Lo = (e) => {
  const {
    prefixCls: t,
    loading: o,
    existIcon: r,
    className: n,
    style: a,
    mount: i
  } = e, l = !!o;
  return r ? /* @__PURE__ */ s.createElement(lt, {
    prefixCls: t,
    className: n,
    style: a
  }) : /* @__PURE__ */ s.createElement(st, {
    visible: l,
    // Used for minus flex gap style only
    motionName: `${t}-loading-icon-motion`,
    motionAppear: !i,
    motionEnter: !i,
    motionLeave: !i,
    removeOnLeave: !0,
    onAppearStart: He,
    onAppearActive: we,
    onEnterStart: He,
    onEnterActive: we,
    onLeaveStart: we,
    onLeaveActive: He
  }, ({
    className: c,
    style: u
  }, d) => {
    const g = Object.assign(Object.assign({}, a), u);
    return /* @__PURE__ */ s.createElement(lt, {
      prefixCls: t,
      className: N(n, c),
      style: g,
      ref: d
    });
  });
}, it = (e, t) => ({
  // Border
  [`> span, > ${e}`]: {
    "&:not(:last-child)": {
      [`&, & > ${e}`]: {
        "&:not(:disabled)": {
          borderInlineEndColor: t
        }
      }
    },
    "&:not(:first-child)": {
      [`&, & > ${e}`]: {
        "&:not(:disabled)": {
          borderInlineStartColor: t
        }
      }
    }
  }
}), Do = (e) => {
  const {
    componentCls: t,
    fontSize: o,
    lineWidth: r,
    groupBorderColor: n,
    colorErrorHover: a
  } = e;
  return {
    [`${t}-group`]: [
      {
        position: "relative",
        display: "inline-flex",
        // Border
        [`> span, > ${t}`]: {
          "&:not(:last-child)": {
            [`&, & > ${t}`]: {
              borderStartEndRadius: 0,
              borderEndEndRadius: 0
            }
          },
          "&:not(:first-child)": {
            marginInlineStart: e.calc(r).mul(-1).equal(),
            [`&, & > ${t}`]: {
              borderStartStartRadius: 0,
              borderEndStartRadius: 0
            }
          }
        },
        [t]: {
          position: "relative",
          zIndex: 1,
          "&:hover, &:focus, &:active": {
            zIndex: 2
          },
          "&[disabled]": {
            zIndex: 0
          }
        },
        [`${t}-icon-only`]: {
          fontSize: o
        }
      },
      // Border Color
      it(`${t}-primary`, n),
      it(`${t}-danger`, a)
    ]
  };
};
var Ao = ["b"], zo = ["v"], Ne = function(t) {
  return Math.round(Number(t || 0));
}, Wo = function(t) {
  if (t instanceof vt)
    return t;
  if (t && ct(t) === "object" && "h" in t && "b" in t) {
    var o = t, r = o.b, n = mt(o, Ao);
    return A(A({}, n), {}, {
      v: r
    });
  }
  return typeof t == "string" && /hsb/.test(t) ? t.replace(/hsb/, "hsv") : t;
}, V = /* @__PURE__ */ function(e) {
  Yt(o, e);
  var t = Jt(o);
  function o(r) {
    return gt(this, o), t.call(this, Wo(r));
  }
  return ft(o, [{
    key: "toHsbString",
    value: function() {
      var n = this.toHsb(), a = Ne(n.s * 100), i = Ne(n.b * 100), l = Ne(n.h), c = n.a, u = "hsb(".concat(l, ", ").concat(a, "%, ").concat(i, "%)"), d = "hsba(".concat(l, ", ").concat(a, "%, ").concat(i, "%, ").concat(c.toFixed(c === 0 ? 0 : 2), ")");
      return c === 1 ? u : d;
    }
  }, {
    key: "toHsb",
    value: function() {
      var n = this.toHsv(), a = n.v, i = mt(n, zo);
      return A(A({}, i), {}, {
        b: a,
        a: this.a
      });
    }
  }]), o;
}(vt), Mo = "rc-color-picker", Y = function(t) {
  return t instanceof V ? t : new V(t);
}, Vo = Y("#1677ff"), Et = function(t) {
  var o = t.offset, r = t.targetRef, n = t.containerRef, a = t.color, i = t.type, l = n.current.getBoundingClientRect(), c = l.width, u = l.height, d = r.current.getBoundingClientRect(), g = d.width, v = d.height, m = g / 2, b = v / 2, E = (o.x + m) / c, p = 1 - (o.y + b) / u, h = a.toHsb(), _ = E, H = (o.x + m) / c * 360;
  if (i)
    switch (i) {
      case "hue":
        return Y(A(A({}, h), {}, {
          h: H <= 0 ? 0 : H
        }));
      case "alpha":
        return Y(A(A({}, h), {}, {
          a: _ <= 0 ? 0 : _
        }));
    }
  return Y({
    h: h.h,
    s: E <= 0 ? 0 : E,
    b: p >= 1 ? 1 : p,
    a: h.a
  });
}, $t = function(t, o) {
  var r = t.toHsb();
  switch (o) {
    case "hue":
      return {
        x: r.h / 360 * 100,
        y: 50
      };
    case "alpha":
      return {
        x: t.a * 100,
        y: 50
      };
    default:
      return {
        x: r.s * 100,
        y: (1 - r.b) * 100
      };
  }
}, Go = function(t) {
  var o = t.color, r = t.prefixCls, n = t.className, a = t.style, i = t.onClick, l = "".concat(r, "-color-block");
  return /* @__PURE__ */ s.createElement("div", {
    className: N(l, n),
    style: a,
    onClick: i
  }, /* @__PURE__ */ s.createElement("div", {
    className: "".concat(l, "-inner"),
    style: {
      background: o
    }
  }));
};
function Fo(e) {
  var t = "touches" in e ? e.touches[0] : e, o = document.documentElement.scrollLeft || document.body.scrollLeft || window.pageXOffset, r = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
  return {
    pageX: t.pageX - o,
    pageY: t.pageY - r
  };
}
function Ot(e) {
  var t = e.targetRef, o = e.containerRef, r = e.direction, n = e.onDragChange, a = e.onDragChangeComplete, i = e.calculate, l = e.color, c = e.disabledDrag, u = Ie({
    x: 0,
    y: 0
  }), d = J(u, 2), g = d[0], v = d[1], m = P(null), b = P(null);
  k(function() {
    v(i());
  }, [l]), k(function() {
    return function() {
      document.removeEventListener("mousemove", m.current), document.removeEventListener("mouseup", b.current), document.removeEventListener("touchmove", m.current), document.removeEventListener("touchend", b.current), m.current = null, b.current = null;
    };
  }, []);
  var E = function(f) {
    var C = Fo(f), L = C.pageX, q = C.pageY, S = o.current.getBoundingClientRect(), O = S.x, I = S.y, j = S.width, y = S.height, W = t.current.getBoundingClientRect(), w = W.width, G = W.height, D = w / 2, U = G / 2, T = Math.max(0, Math.min(L - O, j)) - D, B = Math.max(0, Math.min(q - I, y)) - U, Q = {
      x: T,
      y: r === "x" ? g.y : B
    };
    if (w === 0 && G === 0 || w !== G)
      return !1;
    n == null || n(Q);
  }, p = function(f) {
    f.preventDefault(), E(f);
  }, h = function(f) {
    f.preventDefault(), document.removeEventListener("mousemove", m.current), document.removeEventListener("mouseup", b.current), document.removeEventListener("touchmove", m.current), document.removeEventListener("touchend", b.current), m.current = null, b.current = null, a == null || a();
  }, _ = function(f) {
    document.removeEventListener("mousemove", m.current), document.removeEventListener("mouseup", b.current), !c && (E(f), document.addEventListener("mousemove", p), document.addEventListener("mouseup", h), document.addEventListener("touchmove", p), document.addEventListener("touchend", h), m.current = p, b.current = h);
  };
  return [g, _];
}
var Bt = function(t) {
  var o = t.size, r = o === void 0 ? "default" : o, n = t.color, a = t.prefixCls;
  return /* @__PURE__ */ s.createElement("div", {
    className: N("".concat(a, "-handler"), je({}, "".concat(a, "-handler-sm"), r === "small")),
    style: {
      backgroundColor: n
    }
  });
}, Rt = function(t) {
  var o = t.children, r = t.style, n = t.prefixCls;
  return /* @__PURE__ */ s.createElement("div", {
    className: "".concat(n, "-palette"),
    style: A({
      position: "relative"
    }, r)
  }, o);
}, Ht = /* @__PURE__ */ ie(function(e, t) {
  var o = e.children, r = e.x, n = e.y;
  return /* @__PURE__ */ s.createElement("div", {
    ref: t,
    style: {
      position: "absolute",
      left: "".concat(r, "%"),
      top: "".concat(n, "%"),
      zIndex: 1,
      transform: "translate(-50%, -50%)"
    }
  }, o);
}), qo = function(t) {
  var o = t.color, r = t.onChange, n = t.prefixCls, a = t.onChangeComplete, i = t.disabled, l = P(), c = P(), u = P(o), d = Ae(function(E) {
    var p = Et({
      offset: E,
      targetRef: c,
      containerRef: l,
      color: o
    });
    u.current = p, r(p);
  }), g = Ot({
    color: o,
    containerRef: l,
    targetRef: c,
    calculate: function() {
      return $t(o);
    },
    onDragChange: d,
    onDragChangeComplete: function() {
      return a == null ? void 0 : a(u.current);
    },
    disabledDrag: i
  }), v = J(g, 2), m = v[0], b = v[1];
  return /* @__PURE__ */ s.createElement("div", {
    ref: l,
    className: "".concat(n, "-select"),
    onMouseDown: b,
    onTouchStart: b
  }, /* @__PURE__ */ s.createElement(Rt, {
    prefixCls: n
  }, /* @__PURE__ */ s.createElement(Ht, {
    x: m.x,
    y: m.y,
    ref: c
  }, /* @__PURE__ */ s.createElement(Bt, {
    color: o.toRgbString(),
    prefixCls: n
  })), /* @__PURE__ */ s.createElement("div", {
    className: "".concat(n, "-saturation"),
    style: {
      backgroundColor: "hsl(".concat(o.toHsb().h, ",100%, 50%)"),
      backgroundImage: "linear-gradient(0deg, #000, transparent),linear-gradient(90deg, #fff, hsla(0, 0%, 100%, 0))"
    }
  })));
}, Uo = function(t, o) {
  var r = so(t, {
    value: o
  }), n = J(r, 2), a = n[0], i = n[1], l = ee(function() {
    return Y(a);
  }, [a]);
  return [l, i];
}, Xo = function(t) {
  var o = t.colors, r = t.children, n = t.direction, a = n === void 0 ? "to right" : n, i = t.type, l = t.prefixCls, c = ee(function() {
    return o.map(function(u, d) {
      var g = Y(u);
      return i === "alpha" && d === o.length - 1 && (g = new V(g.setA(1))), g.toRgbString();
    }).join(",");
  }, [o, i]);
  return /* @__PURE__ */ s.createElement("div", {
    className: "".concat(l, "-gradient"),
    style: {
      position: "absolute",
      inset: 0,
      background: "linear-gradient(".concat(a, ", ").concat(c, ")")
    }
  }, r);
}, Yo = function(t) {
  var o = t.prefixCls, r = t.colors, n = t.disabled, a = t.onChange, i = t.onChangeComplete, l = t.color, c = t.type, u = P(), d = P(), g = P(l), v = function(C) {
    return c === "hue" ? C.getHue() : C.a * 100;
  }, m = Ae(function(f) {
    var C = Et({
      offset: f,
      targetRef: d,
      containerRef: u,
      color: l,
      type: c
    });
    g.current = C, a(v(C));
  }), b = Ot({
    color: l,
    targetRef: d,
    containerRef: u,
    calculate: function() {
      return $t(l, c);
    },
    onDragChange: m,
    onDragChangeComplete: function() {
      i(v(g.current));
    },
    direction: "x",
    disabledDrag: n
  }), E = J(b, 2), p = E[0], h = E[1], _ = s.useMemo(function() {
    if (c === "hue") {
      var f = l.toHsb();
      f.s = 1, f.b = 1, f.a = 1;
      var C = new V(f);
      return C;
    }
    return l;
  }, [l, c]), H = s.useMemo(function() {
    return r.map(function(f) {
      return "".concat(f.color, " ").concat(f.percent, "%");
    });
  }, [r]);
  return /* @__PURE__ */ s.createElement("div", {
    ref: u,
    className: N("".concat(o, "-slider"), "".concat(o, "-slider-").concat(c)),
    onMouseDown: h,
    onTouchStart: h
  }, /* @__PURE__ */ s.createElement(Rt, {
    prefixCls: o
  }, /* @__PURE__ */ s.createElement(Ht, {
    x: p.x,
    y: p.y,
    ref: d
  }, /* @__PURE__ */ s.createElement(Bt, {
    size: "small",
    color: _.toHexString(),
    prefixCls: o
  })), /* @__PURE__ */ s.createElement(Xo, {
    colors: H,
    type: c,
    prefixCls: o
  })));
};
function Jo(e) {
  return x.useMemo(function() {
    var t = e || {}, o = t.slider;
    return [o || Yo];
  }, [e]);
}
var Qo = [{
  color: "rgb(255, 0, 0)",
  percent: 0
}, {
  color: "rgb(255, 255, 0)",
  percent: 17
}, {
  color: "rgb(0, 255, 0)",
  percent: 33
}, {
  color: "rgb(0, 255, 255)",
  percent: 50
}, {
  color: "rgb(0, 0, 255)",
  percent: 67
}, {
  color: "rgb(255, 0, 255)",
  percent: 83
}, {
  color: "rgb(255, 0, 0)",
  percent: 100
}], Zo = /* @__PURE__ */ ie(function(e, t) {
  var o = e.value, r = e.defaultValue, n = e.prefixCls, a = n === void 0 ? Mo : n, i = e.onChange, l = e.onChangeComplete, c = e.className, u = e.style, d = e.panelRender, g = e.disabledAlpha, v = g === void 0 ? !1 : g, m = e.disabled, b = m === void 0 ? !1 : m, E = e.components, p = Jo(E), h = J(p, 1), _ = h[0], H = Uo(r || Vo, o), f = J(H, 2), C = f[0], L = f[1], q = ee(function() {
    return C.setA(1).toRgbString();
  }, [C]), S = function(B, Q) {
    o || L(B), i == null || i(B, Q);
  }, O = function(B) {
    return new V(C.setHue(B));
  }, I = function(B) {
    return new V(C.setA(B / 100));
  }, j = function(B) {
    S(O(B), {
      type: "hue",
      value: B
    });
  }, y = function(B) {
    S(I(B), {
      type: "alpha",
      value: B
    });
  }, W = function(B) {
    l && l(O(B));
  }, w = function(B) {
    l && l(I(B));
  }, G = N("".concat(a, "-panel"), c, je({}, "".concat(a, "-panel-disabled"), b)), D = {
    prefixCls: a,
    disabled: b,
    color: C
  }, U = /* @__PURE__ */ s.createElement(s.Fragment, null, /* @__PURE__ */ s.createElement(qo, $e({
    onChange: S
  }, D, {
    onChangeComplete: l
  })), /* @__PURE__ */ s.createElement("div", {
    className: "".concat(a, "-slider-container")
  }, /* @__PURE__ */ s.createElement("div", {
    className: N("".concat(a, "-slider-group"), je({}, "".concat(a, "-slider-group-disabled-alpha"), v))
  }, /* @__PURE__ */ s.createElement(_, $e({}, D, {
    type: "hue",
    colors: Qo,
    min: 0,
    max: 359,
    value: C.getHue(),
    onChange: j,
    onChangeComplete: W
  })), !v && /* @__PURE__ */ s.createElement(_, $e({}, D, {
    type: "alpha",
    colors: [{
      percent: 0,
      color: "rgba(255, 0, 4, 0)"
    }, {
      percent: 100,
      color: q
    }],
    min: 0,
    max: 100,
    value: C.a * 100,
    onChange: y,
    onChangeComplete: w
  }))), /* @__PURE__ */ s.createElement(Go, {
    color: C.toRgbString(),
    prefixCls: a
  })));
  return /* @__PURE__ */ s.createElement("div", {
    className: G,
    style: u,
    ref: t
  }, typeof d == "function" ? d(U) : U);
});
process.env.NODE_ENV !== "production" && (Zo.displayName = "ColorPicker");
const Ko = (e, t) => (e == null ? void 0 : e.replace(/[^\w/]/g, "").slice(0, t ? 8 : 6)) || "", ko = (e, t) => e ? Ko(e, t) : "";
let er = /* @__PURE__ */ function() {
  function e(t) {
    gt(this, e);
    var o;
    if (this.cleared = !1, t instanceof e) {
      this.metaColor = t.metaColor.clone(), this.colors = (o = t.colors) === null || o === void 0 ? void 0 : o.map((n) => ({
        color: new e(n.color),
        percent: n.percent
      })), this.cleared = t.cleared;
      return;
    }
    const r = Array.isArray(t);
    r && t.length ? (this.colors = t.map(({
      color: n,
      percent: a
    }) => ({
      color: new e(n),
      percent: a
    })), this.metaColor = new V(this.colors[0].color.metaColor)) : this.metaColor = new V(r ? "" : t), (!t || r && !this.colors) && (this.metaColor = this.metaColor.setA(0), this.cleared = !0);
  }
  return ft(e, [{
    key: "toHsb",
    value: function() {
      return this.metaColor.toHsb();
    }
  }, {
    key: "toHsbString",
    value: function() {
      return this.metaColor.toHsbString();
    }
  }, {
    key: "toHex",
    value: function() {
      return ko(this.toHexString(), this.metaColor.a < 1);
    }
  }, {
    key: "toHexString",
    value: function() {
      return this.metaColor.toHexString();
    }
  }, {
    key: "toRgb",
    value: function() {
      return this.metaColor.toRgb();
    }
  }, {
    key: "toRgbString",
    value: function() {
      return this.metaColor.toRgbString();
    }
  }, {
    key: "isGradient",
    value: function() {
      return !!this.colors && !this.cleared;
    }
  }, {
    key: "getColors",
    value: function() {
      return this.colors || [{
        color: this,
        percent: 0
      }];
    }
  }, {
    key: "toCssString",
    value: function() {
      const {
        colors: o
      } = this;
      return o ? `linear-gradient(90deg, ${o.map((n) => `${n.color.toRgbString()} ${n.percent}%`).join(", ")})` : this.metaColor.toRgbString();
    }
  }, {
    key: "equals",
    value: function(o) {
      return !o || this.isGradient() !== o.isGradient() ? !1 : this.isGradient() ? this.colors.length === o.colors.length && this.colors.every((r, n) => {
        const a = o.colors[n];
        return r.percent === a.percent && r.color.equals(a.color);
      }) : this.toHexString() === o.toHexString();
    }
  }]);
}();
const tr = (e, t) => {
  const {
    r: o,
    g: r,
    b: n,
    a
  } = e.toRgb(), i = new V(e.toRgbString()).onBackground(t).toHsv();
  return a <= 0.5 ? i.v > 0.5 : o * 0.299 + r * 0.587 + n * 0.114 > 192;
}, wt = (e) => {
  const {
    paddingInline: t,
    onlyIconSize: o
  } = e;
  return se(e, {
    buttonPaddingHorizontal: t,
    buttonPaddingVertical: 0,
    buttonIconOnlyFontSize: o
  });
}, Nt = (e) => {
  var t, o, r, n, a, i;
  const l = (t = e.contentFontSize) !== null && t !== void 0 ? t : e.fontSize, c = (o = e.contentFontSizeSM) !== null && o !== void 0 ? o : e.fontSize, u = (r = e.contentFontSizeLG) !== null && r !== void 0 ? r : e.fontSizeLG, d = (n = e.contentLineHeight) !== null && n !== void 0 ? n : Ee(l), g = (a = e.contentLineHeightSM) !== null && a !== void 0 ? a : Ee(c), v = (i = e.contentLineHeightLG) !== null && i !== void 0 ? i : Ee(u), m = tr(new er(e.colorBgSolid), "#fff") ? "#000" : "#fff", b = ze.reduce((E, p) => Object.assign(Object.assign({}, E), {
    [`${p}ShadowColor`]: `0 ${ne(e.controlOutlineWidth)} 0 ${Qt(e[`${p}1`], e.colorBgContainer)}`
  }), {});
  return Object.assign(Object.assign({}, b), {
    fontWeight: 400,
    defaultShadow: `0 ${e.controlOutlineWidth}px 0 ${e.controlTmpOutline}`,
    primaryShadow: `0 ${e.controlOutlineWidth}px 0 ${e.controlOutline}`,
    dangerShadow: `0 ${e.controlOutlineWidth}px 0 ${e.colorErrorOutline}`,
    primaryColor: e.colorTextLightSolid,
    dangerColor: e.colorTextLightSolid,
    borderColorDisabled: e.colorBorder,
    defaultGhostColor: e.colorBgContainer,
    ghostBg: "transparent",
    defaultGhostBorderColor: e.colorBgContainer,
    paddingInline: e.paddingContentHorizontal - e.lineWidth,
    paddingInlineLG: e.paddingContentHorizontal - e.lineWidth,
    paddingInlineSM: 8 - e.lineWidth,
    onlyIconSize: "inherit",
    onlyIconSizeSM: "inherit",
    onlyIconSizeLG: "inherit",
    groupBorderColor: e.colorPrimaryHover,
    linkHoverBg: "transparent",
    textTextColor: e.colorText,
    textTextHoverColor: e.colorText,
    textTextActiveColor: e.colorText,
    textHoverBg: e.colorFillTertiary,
    defaultColor: e.colorText,
    defaultBg: e.colorBgContainer,
    defaultBorderColor: e.colorBorder,
    defaultBorderColorDisabled: e.colorBorder,
    defaultHoverBg: e.colorBgContainer,
    defaultHoverColor: e.colorPrimaryHover,
    defaultHoverBorderColor: e.colorPrimaryHover,
    defaultActiveBg: e.colorBgContainer,
    defaultActiveColor: e.colorPrimaryActive,
    defaultActiveBorderColor: e.colorPrimaryActive,
    solidTextColor: m,
    contentFontSize: l,
    contentFontSizeSM: c,
    contentFontSizeLG: u,
    contentLineHeight: d,
    contentLineHeightSM: g,
    contentLineHeightLG: v,
    paddingBlock: Math.max((e.controlHeight - l * d) / 2 - e.lineWidth, 0),
    paddingBlockSM: Math.max((e.controlHeightSM - c * g) / 2 - e.lineWidth, 0),
    paddingBlockLG: Math.max((e.controlHeightLG - u * v) / 2 - e.lineWidth, 0)
  });
}, or = (e) => {
  const {
    componentCls: t,
    iconCls: o,
    fontWeight: r,
    opacityLoading: n,
    motionDurationSlow: a,
    motionEaseInOut: i,
    marginXS: l,
    calc: c
  } = e;
  return {
    [t]: {
      outline: "none",
      position: "relative",
      display: "inline-flex",
      gap: e.marginXS,
      alignItems: "center",
      justifyContent: "center",
      fontWeight: r,
      whiteSpace: "nowrap",
      textAlign: "center",
      backgroundImage: "none",
      background: "transparent",
      border: `${ne(e.lineWidth)} ${e.lineType} transparent`,
      cursor: "pointer",
      transition: `all ${e.motionDurationMid} ${e.motionEaseInOut}`,
      userSelect: "none",
      touchAction: "manipulation",
      color: e.colorText,
      "&:disabled > *": {
        pointerEvents: "none"
      },
      // https://github.com/ant-design/ant-design/issues/51380
      [`${t}-icon > svg`]: Kt(),
      "> a": {
        color: "currentColor"
      },
      "&:not(:disabled)": kt(e),
      [`&${t}-two-chinese-chars::first-letter`]: {
        letterSpacing: "0.34em"
      },
      [`&${t}-two-chinese-chars > *:not(${o})`]: {
        marginInlineEnd: "-0.34em",
        letterSpacing: "0.34em"
      },
      [`&${t}-icon-only`]: {
        paddingInline: 0,
        // make `btn-icon-only` not too narrow
        [`&${t}-compact-item`]: {
          flex: "none"
        },
        [`&${t}-round`]: {
          width: "auto"
        }
      },
      // Loading
      [`&${t}-loading`]: {
        opacity: n,
        cursor: "default"
      },
      [`${t}-loading-icon`]: {
        transition: ["width", "opacity", "margin"].map((u) => `${u} ${a} ${i}`).join(",")
      },
      // iconPosition
      [`&:not(${t}-icon-end)`]: {
        [`${t}-loading-icon-motion`]: {
          "&-appear-start, &-enter-start": {
            marginInlineEnd: c(l).mul(-1).equal()
          },
          "&-appear-active, &-enter-active": {
            marginInlineEnd: 0
          },
          "&-leave-start": {
            marginInlineEnd: 0
          },
          "&-leave-active": {
            marginInlineEnd: c(l).mul(-1).equal()
          }
        }
      },
      "&-icon-end": {
        flexDirection: "row-reverse",
        [`${t}-loading-icon-motion`]: {
          "&-appear-start, &-enter-start": {
            marginInlineStart: c(l).mul(-1).equal()
          },
          "&-appear-active, &-enter-active": {
            marginInlineStart: 0
          },
          "&-leave-start": {
            marginInlineStart: 0
          },
          "&-leave-active": {
            marginInlineStart: c(l).mul(-1).equal()
          }
        }
      }
    }
  };
}, _t = (e, t, o) => ({
  [`&:not(:disabled):not(${e}-disabled)`]: {
    "&:hover": t,
    "&:active": o
  }
}), rr = (e) => ({
  minWidth: e.controlHeight,
  paddingInlineStart: 0,
  paddingInlineEnd: 0,
  borderRadius: "50%"
}), nr = (e) => ({
  borderRadius: e.controlHeight,
  paddingInlineStart: e.calc(e.controlHeight).div(2).equal(),
  paddingInlineEnd: e.calc(e.controlHeight).div(2).equal()
}), ar = (e) => ({
  cursor: "not-allowed",
  borderColor: e.borderColorDisabled,
  color: e.colorTextDisabled,
  background: e.colorBgContainerDisabled,
  boxShadow: "none"
}), de = (e, t, o, r, n, a, i, l) => ({
  [`&${e}-background-ghost`]: Object.assign(Object.assign({
    color: o || void 0,
    background: t,
    borderColor: r || void 0,
    boxShadow: "none"
  }, _t(e, Object.assign({
    background: t
  }, i), Object.assign({
    background: t
  }, l))), {
    "&:disabled": {
      cursor: "not-allowed",
      color: n || void 0,
      borderColor: a || void 0
    }
  })
}), lr = (e) => ({
  [`&:disabled, &${e.componentCls}-disabled`]: Object.assign({}, ar(e))
}), ir = (e) => ({
  [`&:disabled, &${e.componentCls}-disabled`]: {
    cursor: "not-allowed",
    color: e.colorTextDisabled
  }
}), ge = (e, t, o, r) => {
  const a = r && ["link", "text"].includes(r) ? ir : lr;
  return Object.assign(Object.assign({}, a(e)), _t(e.componentCls, t, o));
}, fe = (e, t, o, r, n) => ({
  [`&${e.componentCls}-variant-solid`]: Object.assign({
    color: t,
    background: o
  }, ge(e, r, n))
}), me = (e, t, o, r, n) => ({
  [`&${e.componentCls}-variant-outlined, &${e.componentCls}-variant-dashed`]: Object.assign({
    borderColor: t,
    background: o
  }, ge(e, r, n))
}), ve = (e) => ({
  [`&${e.componentCls}-variant-dashed`]: {
    borderStyle: "dashed"
  }
}), pe = (e, t, o, r) => ({
  [`&${e.componentCls}-variant-filled`]: Object.assign({
    boxShadow: "none",
    background: t
  }, ge(e, o, r))
}), z = (e, t, o, r, n) => ({
  [`&${e.componentCls}-variant-${o}`]: Object.assign({
    color: t,
    boxShadow: "none"
  }, ge(e, r, n, o))
}), cr = (e) => {
  const {
    componentCls: t
  } = e;
  return ze.reduce((o, r) => {
    const n = e[`${r}6`], a = e[`${r}1`], i = e[`${r}5`], l = e[`${r}2`], c = e[`${r}3`], u = e[`${r}7`];
    return Object.assign(Object.assign({}, o), {
      [`&${t}-color-${r}`]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        color: n,
        boxShadow: e[`${r}ShadowColor`]
      }, fe(e, e.colorTextLightSolid, n, {
        background: i
      }, {
        background: u
      })), me(e, n, e.colorBgContainer, {
        color: i,
        borderColor: i,
        background: e.colorBgContainer
      }, {
        color: u,
        borderColor: u,
        background: e.colorBgContainer
      })), ve(e)), pe(e, a, {
        background: l
      }, {
        background: c
      })), z(e, n, "link", {
        color: i
      }, {
        color: u
      })), z(e, n, "text", {
        color: i,
        background: a
      }, {
        color: u,
        background: c
      }))
    });
  }, {});
}, sr = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: e.defaultColor,
  boxShadow: e.defaultShadow
}, fe(e, e.solidTextColor, e.colorBgSolid, {
  color: e.solidTextColor,
  background: e.colorBgSolidHover
}, {
  color: e.solidTextColor,
  background: e.colorBgSolidActive
})), ve(e)), pe(e, e.colorFillTertiary, {
  background: e.colorFillSecondary
}, {
  background: e.colorFill
})), de(e.componentCls, e.ghostBg, e.defaultGhostColor, e.defaultGhostBorderColor, e.colorTextDisabled, e.colorBorder)), z(e, e.textTextColor, "link", {
  color: e.colorLinkHover,
  background: e.linkHoverBg
}, {
  color: e.colorLinkActive
})), ur = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: e.colorPrimary,
  boxShadow: e.primaryShadow
}, me(e, e.colorPrimary, e.colorBgContainer, {
  color: e.colorPrimaryTextHover,
  borderColor: e.colorPrimaryHover,
  background: e.colorBgContainer
}, {
  color: e.colorPrimaryTextActive,
  borderColor: e.colorPrimaryActive,
  background: e.colorBgContainer
})), ve(e)), pe(e, e.colorPrimaryBg, {
  background: e.colorPrimaryBgHover
}, {
  background: e.colorPrimaryBorder
})), z(e, e.colorPrimaryText, "text", {
  color: e.colorPrimaryTextHover,
  background: e.colorPrimaryBg
}, {
  color: e.colorPrimaryTextActive,
  background: e.colorPrimaryBorder
})), z(e, e.colorPrimaryText, "link", {
  color: e.colorPrimaryTextHover,
  background: e.linkHoverBg
}, {
  color: e.colorPrimaryTextActive
})), de(e.componentCls, e.ghostBg, e.colorPrimary, e.colorPrimary, e.colorTextDisabled, e.colorBorder, {
  color: e.colorPrimaryHover,
  borderColor: e.colorPrimaryHover
}, {
  color: e.colorPrimaryActive,
  borderColor: e.colorPrimaryActive
})), dr = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: e.colorError,
  boxShadow: e.dangerShadow
}, fe(e, e.dangerColor, e.colorError, {
  background: e.colorErrorHover
}, {
  background: e.colorErrorActive
})), me(e, e.colorError, e.colorBgContainer, {
  color: e.colorErrorHover,
  borderColor: e.colorErrorBorderHover
}, {
  color: e.colorErrorActive,
  borderColor: e.colorErrorActive
})), ve(e)), pe(e, e.colorErrorBg, {
  background: e.colorErrorBgFilledHover
}, {
  background: e.colorErrorBgActive
})), z(e, e.colorError, "text", {
  color: e.colorErrorHover,
  background: e.colorErrorBg
}, {
  color: e.colorErrorHover,
  background: e.colorErrorBgActive
})), z(e, e.colorError, "link", {
  color: e.colorErrorHover
}, {
  color: e.colorErrorActive
})), de(e.componentCls, e.ghostBg, e.colorError, e.colorError, e.colorTextDisabled, e.colorBorder, {
  color: e.colorErrorHover,
  borderColor: e.colorErrorHover
}, {
  color: e.colorErrorActive,
  borderColor: e.colorErrorActive
})), gr = (e) => Object.assign(Object.assign({}, z(e, e.colorLink, "link", {
  color: e.colorLinkHover
}, {
  color: e.colorLinkActive
})), de(e.componentCls, e.ghostBg, e.colorInfo, e.colorInfo, e.colorTextDisabled, e.colorBorder, {
  color: e.colorInfoHover,
  borderColor: e.colorInfoHover
}, {
  color: e.colorInfoActive,
  borderColor: e.colorInfoActive
})), fr = (e) => {
  const {
    componentCls: t
  } = e;
  return Object.assign({
    [`${t}-color-default`]: sr(e),
    [`${t}-color-primary`]: ur(e),
    [`${t}-color-dangerous`]: dr(e),
    [`${t}-color-link`]: gr(e)
  }, cr(e));
}, mr = (e) => Object.assign(Object.assign(Object.assign(Object.assign({}, me(e, e.defaultBorderColor, e.defaultBg, {
  color: e.defaultHoverColor,
  borderColor: e.defaultHoverBorderColor,
  background: e.defaultHoverBg
}, {
  color: e.defaultActiveColor,
  borderColor: e.defaultActiveBorderColor,
  background: e.defaultActiveBg
})), z(e, e.textTextColor, "text", {
  color: e.textTextHoverColor,
  background: e.textHoverBg
}, {
  color: e.textTextActiveColor,
  background: e.colorBgTextActive
})), fe(e, e.primaryColor, e.colorPrimary, {
  background: e.colorPrimaryHover,
  color: e.primaryColor
}, {
  background: e.colorPrimaryActive,
  color: e.primaryColor
})), z(e, e.colorLink, "link", {
  color: e.colorLinkHover,
  background: e.linkHoverBg
}, {
  color: e.colorLinkActive
})), We = (e, t = "") => {
  const {
    componentCls: o,
    controlHeight: r,
    fontSize: n,
    borderRadius: a,
    buttonPaddingHorizontal: i,
    iconCls: l,
    buttonPaddingVertical: c,
    buttonIconOnlyFontSize: u
  } = e;
  return [
    {
      [t]: {
        fontSize: n,
        height: r,
        padding: `${ne(c)} ${ne(i)}`,
        borderRadius: a,
        [`&${o}-icon-only`]: {
          width: r,
          [l]: {
            fontSize: u
          }
        }
      }
    },
    // Shape - patch prefixCls again to override solid border radius style
    {
      [`${o}${o}-circle${t}`]: rr(e)
    },
    {
      [`${o}${o}-round${t}`]: nr(e)
    }
  ];
}, vr = (e) => {
  const t = se(e, {
    fontSize: e.contentFontSize
  });
  return We(t, e.componentCls);
}, pr = (e) => {
  const t = se(e, {
    controlHeight: e.controlHeightSM,
    fontSize: e.contentFontSizeSM,
    padding: e.paddingXS,
    buttonPaddingHorizontal: e.paddingInlineSM,
    buttonPaddingVertical: 0,
    borderRadius: e.borderRadiusSM,
    buttonIconOnlyFontSize: e.onlyIconSizeSM
  });
  return We(t, `${e.componentCls}-sm`);
}, br = (e) => {
  const t = se(e, {
    controlHeight: e.controlHeightLG,
    fontSize: e.contentFontSizeLG,
    buttonPaddingHorizontal: e.paddingInlineLG,
    buttonPaddingVertical: 0,
    borderRadius: e.borderRadiusLG,
    buttonIconOnlyFontSize: e.onlyIconSizeLG
  });
  return We(t, `${e.componentCls}-lg`);
}, hr = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      [`&${t}-block`]: {
        width: "100%"
      }
    }
  };
}, Cr = Zt("Button", (e) => {
  const t = wt(e);
  return [
    // Shared
    or(t),
    // Size
    vr(t),
    pr(t),
    br(t),
    // Block
    hr(t),
    // Color
    fr(t),
    // https://github.com/ant-design/ant-design/issues/50969
    mr(t),
    // Button Group
    Do(t)
  ];
}, Nt, {
  unitless: {
    fontWeight: !0,
    contentLineHeight: !0,
    contentLineHeightSM: !0,
    contentLineHeightLG: !0
  }
});
function yr(e, t) {
  return {
    // border collapse
    [`&-item:not(${t}-last-item)`]: {
      marginBottom: e.calc(e.lineWidth).mul(-1).equal()
    },
    "&-item": {
      "&:hover,&:focus,&:active": {
        zIndex: 2
      },
      "&[disabled]": {
        zIndex: 0
      }
    }
  };
}
function Sr(e, t) {
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item)`]: {
      borderRadius: 0
    },
    [`&-item${t}-first-item:not(${t}-last-item)`]: {
      [`&, &${e}-sm, &${e}-lg`]: {
        borderEndEndRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&-item${t}-last-item:not(${t}-first-item)`]: {
      [`&, &${e}-sm, &${e}-lg`]: {
        borderStartStartRadius: 0,
        borderStartEndRadius: 0
      }
    }
  };
}
function xr(e) {
  const t = `${e.componentCls}-compact-vertical`;
  return {
    [t]: Object.assign(Object.assign({}, yr(e, t)), Sr(e.componentCls, t))
  };
}
const Er = (e) => {
  const {
    componentCls: t,
    colorPrimaryHover: o,
    lineWidth: r,
    calc: n
  } = e, a = n(r).mul(-1).equal(), i = (l) => {
    const c = `${t}-compact${l ? "-vertical" : ""}-item${t}-primary:not([disabled])`;
    return {
      [`${c} + ${c}::before`]: {
        position: "absolute",
        top: l ? a : 0,
        insetInlineStart: l ? 0 : a,
        backgroundColor: o,
        content: '""',
        width: l ? "100%" : r,
        height: l ? r : "100%"
      }
    };
  };
  return Object.assign(Object.assign({}, i()), i(!0));
}, $r = eo(["Button", "compact"], (e) => {
  const t = wt(e);
  return [
    // Space Compact
    fo(t),
    xr(t),
    Er(t)
  ];
}, Nt);
var Or = function(e, t) {
  var o = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (o[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
    t.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (o[r[n]] = e[r[n]]);
  return o;
};
function Br(e) {
  if (typeof e == "object" && e) {
    let t = e == null ? void 0 : e.delay;
    return t = !Number.isNaN(t) && typeof t == "number" ? t : 0, {
      loading: t <= 0,
      delay: t
    };
  }
  return {
    loading: !!e,
    delay: 0
  };
}
const Rr = {
  default: ["default", "outlined"],
  primary: ["primary", "solid"],
  dashed: ["default", "dashed"],
  // `link` is not a real color but we should compatible with it
  link: ["link", "link"],
  text: ["default", "text"]
}, Hr = /* @__PURE__ */ s.forwardRef((e, t) => {
  var o, r;
  const {
    loading: n = !1,
    prefixCls: a,
    color: i,
    variant: l,
    type: c,
    danger: u = !1,
    shape: d = "default",
    size: g,
    styles: v,
    disabled: m,
    className: b,
    rootClassName: E,
    children: p,
    icon: h,
    iconPosition: _ = "start",
    ghost: H = !1,
    block: f = !1,
    // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType: C = "button",
    classNames: L,
    style: q = {},
    autoInsertSpace: S,
    autoFocus: O
  } = e, I = Or(e, ["loading", "prefixCls", "color", "variant", "type", "danger", "shape", "size", "styles", "disabled", "className", "rootClassName", "children", "icon", "iconPosition", "ghost", "block", "htmlType", "classNames", "style", "autoInsertSpace", "autoFocus"]), j = c || "default", {
    button: y
  } = s.useContext(ce), [W, w] = ee(() => {
    if (i && l)
      return [i, l];
    if (c || u) {
      const R = Rr[j] || [];
      return u ? ["danger", R[1]] : R;
    }
    return y != null && y.color && (y != null && y.variant) ? [y.color, y.variant] : ["default", "outlined"];
  }, [c, i, l, u, y == null ? void 0 : y.variant, y == null ? void 0 : y.color]), D = W === "danger" ? "dangerous" : W, {
    getPrefixCls: U,
    direction: T,
    autoInsertSpace: B,
    className: Q,
    style: It,
    classNames: jt,
    styles: Tt
  } = to("button"), be = (o = S ?? B) !== null && o !== void 0 ? o : !0, $ = U("btn", a), [Ve, Pt, Lt] = Cr($), Dt = _e(io), X = m ?? Dt, At = _e(xt), Z = ee(() => Br(n), [n]), [F, Ge] = Ie(Z.loading), [he, Fe] = Ie(!1), K = P(null), qe = oo(t, K), Ue = Vt.count(p) === 1 && !h && !oe(w), Ce = P(!0);
  s.useEffect(() => (Ce.current = !1, () => {
    Ce.current = !0;
  }), []), k(() => {
    let R = null;
    Z.delay > 0 ? R = setTimeout(() => {
      R = null, Ge(!0);
    }, Z.delay) : Ge(Z.loading);
    function M() {
      R && (clearTimeout(R), R = null);
    }
    return M;
  }, [Z]), k(() => {
    if (!K.current || !be)
      return;
    const R = K.current.textContent || "";
    Ue && Le(R) ? he || Fe(!0) : he && Fe(!1);
  }), k(() => {
    O && K.current && K.current.focus();
  }, []);
  const Xe = s.useCallback((R) => {
    var M;
    if (F || X) {
      R.preventDefault();
      return;
    }
    (M = e.onClick) === null || M === void 0 || M.call(e, ("href" in e, R));
  }, [e.onClick, F, X]);
  if (process.env.NODE_ENV !== "production") {
    const R = pt("Button");
    process.env.NODE_ENV !== "production" && R(!(typeof h == "string" && h.length > 2), "breaking", `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${h}\` at https://ant.design/components/icon`), process.env.NODE_ENV !== "production" && R(!(H && oe(w)), "usage", "`link` or `text` button can't be a `ghost` button.");
  }
  const {
    compactSize: zt,
    compactItemClassnames: Ye
  } = lo($, T), Wt = {
    large: "lg",
    small: "sm",
    middle: void 0
  }, Je = uo((R) => {
    var M, xe;
    return (xe = (M = g ?? zt) !== null && M !== void 0 ? M : At) !== null && xe !== void 0 ? xe : R;
  }), Qe = Je && (r = Wt[Je]) !== null && r !== void 0 ? r : "", Mt = F ? "loading" : h, ye = ro(I, ["navigate"]), Ze = N($, Pt, Lt, {
    [`${$}-${d}`]: d !== "default" && d,
    // Compatible with versions earlier than 5.21.0
    [`${$}-${j}`]: j,
    [`${$}-dangerous`]: u,
    [`${$}-color-${D}`]: D,
    [`${$}-variant-${w}`]: w,
    [`${$}-${Qe}`]: Qe,
    [`${$}-icon-only`]: !p && p !== 0 && !!Mt,
    [`${$}-background-ghost`]: H && !oe(w),
    [`${$}-loading`]: F,
    [`${$}-two-chinese-chars`]: he && be && !F,
    [`${$}-block`]: f,
    [`${$}-rtl`]: T === "rtl",
    [`${$}-icon-end`]: _ === "end"
  }, Ye, b, E, Q), Ke = Object.assign(Object.assign({}, It), q), ke = N(L == null ? void 0 : L.icon, jt.icon), et = Object.assign(Object.assign({}, (v == null ? void 0 : v.icon) || {}), Tt.icon || {}), tt = h && !F ? /* @__PURE__ */ s.createElement(De, {
    prefixCls: $,
    className: ke,
    style: et
  }, h) : n && typeof n == "object" && n.icon ? /* @__PURE__ */ s.createElement(De, {
    prefixCls: $,
    className: ke,
    style: et
  }, n.icon) : /* @__PURE__ */ s.createElement(Lo, {
    existIcon: !!h,
    prefixCls: $,
    loading: F,
    mount: Ce.current
  }), ot = p || p === 0 ? Po(p, Ue && be) : null;
  if (ye.href !== void 0)
    return Ve(/* @__PURE__ */ s.createElement("a", Object.assign({}, ye, {
      className: N(Ze, {
        [`${$}-disabled`]: X
      }),
      href: X ? void 0 : ye.href,
      style: Ke,
      onClick: Xe,
      ref: qe,
      tabIndex: X ? -1 : 0
    }), tt, ot));
  let Se = /* @__PURE__ */ s.createElement("button", Object.assign({}, I, {
    type: C,
    className: Ze,
    style: Ke,
    onClick: Xe,
    disabled: X,
    ref: qe
  }), tt, ot, Ye && /* @__PURE__ */ s.createElement($r, {
    prefixCls: $
  }));
  return oe(w) || (Se = /* @__PURE__ */ s.createElement(St, {
    component: "Button",
    disabled: F
  }, Se)), Ve(Se);
}), Me = Hr;
Me.Group = jo;
Me.__ANT_BUTTON = !0;
process.env.NODE_ENV !== "production" && (Me.displayName = "Button");
export {
  Me as B,
  yt as T,
  St as W,
  Wr as c,
  Oo as u
};
